import React from 'react';
import { st, classes } from './Header.st.css';
import { Heading } from '../../../Heading';
import { Text } from '../../../Text';
import { DATA_HOOKS } from './Header.constants';
import { isString } from '../../../utils/StringUtils';
import { HeaderProps } from './Header.types';

const Header = ({
  dataHook,
  title,
  subtitle,
  suffix,
  className,
}: HeaderProps) => {
  return (
    <div data-hook={dataHook} className={st(classes.root, {}, className)}>
      <div className={classes.titleWrapper}>
        {isString(title) ? (
          <Heading
            dataHook={DATA_HOOKS.title}
            size="medium"
            children={title}
            className={classes.title}
          />
        ) : (
          <span data-hook={DATA_HOOKS.title}>{title}</span>
        )}

        {subtitle &&
          (isString(subtitle) ? (
            <Text
              dataHook={DATA_HOOKS.subtitle}
              children={subtitle}
              secondary
              className={classes.subtitle}
            />
          ) : (
            <span data-hook={DATA_HOOKS.subtitle}>{subtitle}</span>
          ))}
      </div>

      {suffix && (
        <div
          data-hook={DATA_HOOKS.suffix}
          className={classes.suffix}
          children={suffix}
        />
      )}
    </div>
  );
};

Header.displayName = 'Card.Header';

export { Header };
